module.exports = __webpack_public_path__ + "img/ring_r_o_0_null@2x.bdf83eee.png";